/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import Plans from '../user/Plans';

import Text from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

export default function Step4() {
  const { t } = useTranslation();
  return (
    <div>
      <Text variant="h6" fontWeight="700">
        {t('Prova abonnemang gratis i 7 dagar!')}
      </Text>
      <div
        css={css`
          padding: 8px 16px;
          border-radius: 8px;
          background-color: rgba(255, 179, 0, 0.08);
          box-sizing: border-box;
          display: inline-block;
        `}
      >
        <Text variant="body1">{t('Nuvarande abonnemang: Gratis')}</Text>
      </div>
      <Plans />
    </div>
  );
}
